<template>
  <f-dashboard-content-wrapper>
    <f-loader v-if="partner === undefined"></f-loader>
  
    <partner-card
      v-if="partner"
      class="m-bottom-20"
      :id="partnerId"
      editable
    ></partner-card>

    <div class="max-width-500 is-margin-auto">
      <h6>Infos</h6>

      <partner-infos
        v-if="partner" 
        :id="partnerId"
      ></partner-infos>

      <!-- <div class="is-col-12">
        <hr>
      </div>

      <h6>Contacts</h6>

      <partner-contacts
        v-if="partner" 
        :id="partnerId"
      ></partner-contacts> -->
    </div>
  </f-dashboard-content-wrapper>
</template>

<script>
  import { computed, ref } from 'vue'
  import { useStore } from '@freebe/sdk/store'
  import router from '@core/router'
  import PartnerCard from '@components/partners/view/partner-card'
  import PartnerInfos from '@components/partners/edit-infos'
  import PartnerContacts from '@components/partners/edit-contacts'

  export default {
    setup () {
      const partnerId = computed(() => router.currentRoute.value.params.partner_id)
      const { get, fetch } = useStore('@admin/partners')

      const partner = computed(() =>
        get(partnerId.value)
      )
      fetch(partnerId.value)

      return {
        partner,
        partnerId,
      }
    }, 

    components: {
      PartnerCard,
      PartnerInfos,
      PartnerContacts,
    }
  }
</script>
